import { departmentServices } from "../../Services/DepartmentServices/department.services";


const departmentListing = async () => {
    let response = await departmentServices.departmentListing();
    if (response && response.status) {
        return response;
    } else {
        return null;
    }
};

const departmentCreate = async () => {
    let post = {
        "title": "Endocrinology & Diabetes 22",
        "hospital": ["1", "4", "10"]
    }
    let response = await departmentServices.departmentCreate(post);
    if (response && response.status) {
        return response;
    } else {
        return null;
    }
};


const departmentDetail = async (id) => {
    let response = await departmentServices.departmentDetail(id);
    if (response && response.status) {
        return response;
    } else {
        return null;
    }
};


const departmentUpdate = async (id) => {
    let response = await departmentServices.departmentUpdate(id);
    if (response && response.status) {
        return response;
    } else {
        return null;
    }
};


const departmentDelete = async (id) => {
    let response = await departmentServices.departmentDelete(id);
    if (response && response.status) {
        return response;
    } else {
        return null;
    }
};


const departmentController = {
    departmentListing,
    departmentCreate,
    departmentDetail,
    departmentUpdate,
    departmentDelete
};

export default departmentController;
